module.exports = __webpack_public_path__ + "img/Realisme_De_fire_store_Ibsen.2f312130.jpg";